var exports = {
  "HG": "xcc377c0b--de0360--builder-call-reasons",
  "Qs": "xcc377c0b--de0360--content",
  "Sl": "xcc377c0b--de0360--image",
  "$O": "xcc377c0b--de0360--clarification",
  "Ot": "xcc377c0b--de0360--reasons",
  "l": "xcc377c0b--de0360--reason",
};

module.exports = exports;
